// import React from "react";
// import { Link } from "react-router-dom";

// const SideBarSubCategory = (props) => {
//   const Wrapper = props.Link ? Link : "div";

//   return (
//     <Wrapper
//       to={props.Link}
//       onClick={props.onClick}
//       className="yes-bm-sub-category-box"
//       style={{ height: `${props.height}px`, opacity: `${props.Opacity}` }}
//     >
//       <i className="fa-solid fa-caret-right floting-arrow"></i>
//       {props.heading}
//       <i className="fa-solid fa-caret-right fixed-arrow"></i>
//     </Wrapper>
//   );
// };

// export default SideBarSubCategory;




import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const SideBarSubCategory = (props) => {
  const {
    Link: linkHref,
    onClick,
    height,
    Opacity,
    heading,
  } = props;

  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false)

  const handleClick = (e) => {
    if (onClick) onClick(e);

    if (!linkHref) return;

    if (e.ctrlKey || e.metaKey) {
      // Open in new tab
      window.open(linkHref, "_blank", "noopener,noreferrer");
      e.preventDefault(); // prevent default React Router navigation
    } else {
      // Navigate normally
      navigate(linkHref);
      e.preventDefault();
    }
  };

  return (
    <div
      onClick={handleClick}
      className="yes-bm-sub-category-box"
      style={{ height: `${height}px`, opacity: `${Opacity}` }}
    >
      <i className="fa-solid fa-caret-right floting-arrow "></i>
      {/* <p
        title={linkHref ? "Ctrl+Click to open in a new tab" : ""}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          margin: '0px',
          width: '220px',
          height: '35px',

          textAlign: 'center',
          cursor: 'pointer',
          transition: 'color 0.1s',
        }}
      >
        {heading}
      </p> */}
      <div style={{ position: 'relative', display: 'inline-block', }}>
        <p className="heading-tooltip"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {heading}
        </p>
        {linkHref && showTooltip && (
          <div className="custom-tooltip">
            Ctrl+Click to open in a new tab
          </div>
        )}
      </div>

      <i className="fa-solid fa-caret-right fixed-arrow "></i>
    </div>
  );
};

export default SideBarSubCategory;
